module.exports = __webpack_public_path__ + "img/atencao.c6040653.jpg";